<template lang="html">
  <div class="preferential-bubble vh100" v-if="isBubbleShow">
    <div class="preferential-bubble-main">
      <img src="./images/icon.png" alt="" class="icon">
      <div class="preferential-bubble-title">
        <h1>您已成功领取第一笔奖学基金</h1>
        <p>快去探索未知的世界吧</p>
      </div>
      <ul class="preferential-bubble-coupon">
        <li v-for="(item, index) in couponPopList" :key="index">
          <CouponItem :couponInfo="item" :useEnd="item.useEnd"></CouponItem>
        </li>
      </ul>
      <div class="preferential-bubble-button" @click="isBubbleShow = !isBubbleShow">
        立即抢课
      </div>
    </div>
  </div>
</template>

<script>
import CouponItem from './CouponItem'
export default {
  name: 'PreferentialBubble',
  props: ['couponPopList'],
  data () {
    return {
      isBubbleShow: true
    }
  },
  methods: {
  },
  components: {
    CouponItem
  }
}
</script>

<style lang="scss">
@charset "UTF-8";
@import "../../style/main";

.preferential-bubble {
  position: fixed;
  width: 100%;
  /*height: 100%;*/
  top: rem(0);
  left: rem(0);
  background-color: rgba(0, 0, 0, .6);
  &-button {
    width: rem(450);
    height: rem(74);
    line-height: rem(74);
    color: #fff;
    border-radius: rem(50);
    background-image: linear-gradient(to right, #FFB500, #F48F00);
    margin: auto;
    margin-top: rem(25);
    text-align: center;
    font-size: rem(36);
    box-shadow: rgba(#D71A1A, .44) rem(0) rem(6) rem(10) rem(0);
    font-weight: bold;
  }
  &-main {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: rem(630);
    /*height: rem(1014);*/
    background-color: #F54545;
    padding: rem(73) rem(30) rem(42) rem(30);
    border-radius: rem(15);
    box-sizing: border-box;
  }
  .icon {
    width: rem(411);
    /*height: rem(98);*/
    position: absolute;
    top: rem(-40);
    left: 50%;
    transform: translateX(-50%);
  }
  &-title {
    line-height: 1.3;
    text-align: center;
    margin-bottom: rem(25);
    h1 {
      font-size: rem(40);
      font-weight: bold;
      color: #FAF2E1;
      text-shadow: rgba(#CE2424, .55) 0 rem(6) rem(8);
    }
    p {
      font-size: rem(28);
      color: #fff;
    }
  }
}
</style>
